import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { Button } from '../../../shared/components/Button';
import DotsHorizontalIcon from '../../../shared/components/Icon/DotsHorizontalIcon';
import { Popover, PopoverContent, PopoverTrigger, } from '../../../shared/components/Popover';
import { QueryKeys } from '../../../shared/constants';
import { route } from '../../../shared/utils';
const useGetEmailTemplateList = () => {
    const fields = [
        {
            heading: 'Template',
            key: 'id',
        },
        {
            heading: 'Template title',
            key: 'name',
        },
        {
            heading: 'Notification Type',
            key: 'notification_type',
        },
        {
            heading: 'Date created',
            key: 'created_at',
            itemShouldRender: (item) => {
                return item.created_at ? format(item.created_at, 'MM/dd/yyyy') : '';
            },
        },
        {
            heading: 'Status',
            key: 'status',
            itemShouldRender: (item) => {
                return item.status;
            },
        },
        {
            heading: 'Action',
            key: 'action',
            itemShouldRender: (item) => {
                return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Button, { variant: "outline", className: "border-none", children: _jsx(DotsHorizontalIcon, {}) }) }), _jsx(PopoverContent, { className: "w-[162px] p-[0px]", children: _jsxs("div", { className: "text-[#4B5563] text-[14px] leading-[16px]", children: [_jsx(Link, { to: route(`/templates/emails/edit?id=${item.id}`), children: _jsx("div", { className: "pt-[10px] pb-[10px] pl-[16px] pr-[16px] hover:bg-[#E5E7EB]", children: "Edit template" }) }), _jsx("div", { className: "pt-[10px] pb-[10px] pl-[16px] pr-[16px]", children: "View this version" }), _jsx("div", { className: "pt-[10px] pb-[10px] pl-[16px] pr-[16px]", children: "Restore this version" }), _jsx("div", { className: "pt-[10px] pb-[10px] pl-[16px] pr-[16px]", children: "Duplicate" }), _jsx("div", { className: "pt-[10px] pb-[10px] pl-[16px] pr-[16px]", children: "Delete template" }), _jsx("div", { className: "pt-[10px] pb-[10px] pl-[16px] pr-[16px]", children: "Copy link" })] }) })] }));
            },
        },
    ];
    const { data } = useQuery({
        queryKey: [QueryKeys.GetEmailTemplateList],
        queryFn: () => {
            return [
                {
                    id: '014-556',
                    name: 'January Sales',
                    notification_type: 'Welcome email',
                    created_at: '2/11/2022',
                    status: 'Draft',
                },
                {
                    id: '04-658',
                    name: 'Termites have your house in shambles?',
                    notification_type: 'Promotional',
                    created_at: '4/4/2024',
                    status: 'Inactive',
                },
                {
                    id: '04-538',
                    name: 'October Savings',
                    notification_type: 'Service Reminder',
                    created_at: '10/10/2022',
                    status: 'Active',
                },
            ];
        },
    });
    return { fields, data };
};
export default useGetEmailTemplateList;
